import { render } from "./editSort.vue?vue&type=template&id=1b697def&scoped=true"
import script from "./editSort.vue?vue&type=script&lang=js"
export * from "./editSort.vue?vue&type=script&lang=js"

import "./editSort.vue?vue&type=style&index=0&id=1b697def&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b697def"],['__file',"src/views/brand/components/editSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b697def"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b697def', __exports__)) {
    console.log('reload')
    api.reload('1b697def', __exports__)
  }
  
  module.hot.accept("./editSort.vue?vue&type=template&id=1b697def&scoped=true", () => {
    console.log('re-render')
    api.rerender('1b697def', render)
  })

}


export default __exports__